module.exports = require("tslib");